import { FieldNameEnum, RelatedDataEntity } from '@mark43/cad-api';
import { HStack, Box, DataList, DataItem } from '@cad-arc';
import { formatMonthDayYearHoursMinutes } from '../../../common/helpers/utils';
import { LinkText } from '../../../common/components/link-text';
import { useCallback } from 'react';
import { useBootstrapState } from '../../../bootstrap/bootstrap-provider';
import { useOpenDepartmentLink } from '../../../layout/use-open-department-link';
import { NarrativePopover } from '../../../related-data/narrative-popover';
import { DATA_ITEM_LINE_HEIGHT } from './constants';

export const RmsHistoryOrVehicleRow = ({ entity }: { entity: RelatedDataEntity }) => {
    const openDepartmentLink = useOpenDepartmentLink();

    const onClickEventNumber = useCallback(
        (e) => {
            e.stopPropagation();
            openDepartmentLink({
                path: `/reports/${entity.entityId}`,
                app: 'RMS',
                tenantStrategy: 'PREFER_RMS_TENANT',
            });
        },
        [openDepartmentLink, entity.entityId]
    );

    const { fieldDisplayNameByFieldName: fieldDisplayNames } = useBootstrapState();
    const renDisplayName =
        fieldDisplayNames[FieldNameEnum.AGENCY_EVENT_REPORTING_EVENT_NUMBER.name];

    return (
        <HStack width="100%" align="top">
            <Box width="55%">
                <DataList variant="inline" spacing="1">
                    <DataItem dataKey={`${renDisplayName} / Owner`}>
                        <LinkText fontSize="sm" onClick={onClickEventNumber}>
                            {entity.entityNumber}
                        </LinkText>
                    </DataItem>
                    <DataItem dataKey="Report Type / Class">{entity.title}</DataItem>
                </DataList>
            </Box>
            <Box width="45%">
                <DataList variant="inline" spacing="1">
                    <DataItem dataKey="Created">
                        {formatMonthDayYearHoursMinutes(entity.createdDateUtc)}
                    </DataItem>
                    <Box
                        style={{
                            lineHeight: DATA_ITEM_LINE_HEIGHT,
                        }}
                    >
                        {entity.subtitle && <NarrativePopover narrative={entity.subtitle} />}
                    </Box>
                </DataList>
            </Box>
        </HStack>
    );
};
